import React from 'react';
import { CheckIcon, CreditCardIcon, ShieldCheckIcon, StarIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { HERO_IMAGE } from '../data/content';
import { HERO_SIZES, HERO_WIDTHS, optimizedImage, optimizedSrcSet } from '../utils/images';
const guarantees = ['Acceso inmediato', 'Para docentes de Hispanoamérica', 'Pago seguro'];
export function Hero() {
  return <header className="w-full bg-cream-100 px-6 pb-10 pt-5 sm:pt-7" data-id="element-86" data-mp="1297aw07qkt7q">
      <div className="mx-auto flex max-w-5xl flex-col items-center text-center" data-id="element-87" data-mp="127ect9b6vhbc">
        <span className="rounded-full bg-cream-200 px-5 py-1.5 text-xs font-semibold tracking-[0.22em] text-forest-700" data-id="element-88" data-mp="xb5tdjpyl1yd">
          KIT INSTRUMENTACIÓN INDUSTRIAL 2026
        </span>

        <h1 className="mt-4 font-display text-4xl font-bold leading-[1.02] text-forest-800 sm:text-6xl lg:text-7xl" data-id="element-89" data-mp="nbez9j5b8oyt">
          Del Sensor al Aula.
          <span className="block text-ember-500" data-id="element-90" data-mp="382fedm0930dv">Todo resuelto.</span>
        </h1>

        <img src={optimizedImage(HERO_IMAGE, 576)} srcSet={optimizedSrcSet(HERO_IMAGE, HERO_WIDTHS)} sizes={HERO_SIZES} alt="Los 6 volúmenes del Kit Instrumentación Industrial 2026 junto a los 5 bonos, material imprimible y recursos digitales" width={1000} height={1000} fetchPriority="high" decoding="async" className="-my-4 h-auto w-full max-w-xl sm:-my-6" data-id="element-91" data-mp="384jtz17ihntz" />

        <p className="max-w-2xl text-base leading-relaxed text-forest-700/85 sm:text-lg" data-id="element-92" data-mp="3e84odf6up2vm">
          Kit Instrumentación Industrial con 6 volúmenes técnicos, 5 bonos estratégicos e implementación
          docente 360°.
        </p>

        <ul className="mt-4 flex flex-col items-center gap-1.5 text-sm text-forest-600 sm:flex-row sm:gap-7 sm:text-base" data-id="element-93" data-mp="35aubxqiar7p4">
          {guarantees.map(item => <li key={item} className="flex items-center gap-2" data-id="element-94" data-mp="2vi54d6pvadz2">
              <CheckIcon className="h-4 w-4 text-forest-400" aria-hidden="true" data-id="element-95" data-mp="2vglpnkjv0aze" />
              {item}
            </li>)}
        </ul>

        <CtaButton className="mt-6" source="hero" data-id="element-96" data-mp="2ll0f2y0q62e1" />

        <div className="mt-4 flex flex-col items-center gap-2 text-sm text-forest-700/85 sm:flex-row sm:gap-5" data-id="element-97" data-mp="2lmuz8a469qh2">
          <span className="flex items-center gap-2" data-id="element-98" data-mp="s3undmopqq5v">
            <span className="flex" aria-hidden="true" data-id="element-99" data-mp="najhpovn0ffj">
              {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="h-4 w-4 fill-ember-400 text-ember-400" data-id="element-100" data-mp="ibgor2sxlznx" />)}
            </span>
            4.9/5 — +150 docentes
          </span>
          <span className="hidden h-4 w-px bg-cream-300 sm:block" aria-hidden="true" data-id="element-101" data-mp="dbaowzcid6ur" />
          <span className="flex items-center gap-2" data-id="element-102" data-mp="1ayt9d7fj7xel">
            <ShieldCheckIcon className="h-4 w-4 text-forest-400" aria-hidden="true" data-id="element-103" data-mp="161jcj6ptcjgq" />
            Garantía 7 Días
          </span>
          <span className="hidden h-4 w-px bg-cream-300 sm:block" aria-hidden="true" data-id="element-104" data-mp="111525i0qoxfj" />
          <span className="flex items-center gap-2" data-id="element-105" data-mp="x0csworvasj9">
            <CreditCardIcon className="h-4 w-4 text-forest-400" aria-hidden="true" data-id="element-106" data-mp="3lsypkqaae6eu" />
            Tarjeta · Mercado Pago
          </span>
        </div>
      </div>
    </header>;
}